import { useEffect } from "react";
import { IonSkeletonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { FeedItem } from "./FeedItem";
import { getPostPreview } from "../../redux/actions/postActions";

const PostLinkPreview = ({ postId }) => {
  const dispatch = useDispatch();
  const { postPreviews, loading, error } = useSelector((state) => state.post);
  const post = postPreviews[postId];

  useEffect(() => {
    if (postId && !post && !loading) {
      dispatch(getPostPreview(postId));
    }
  }, [postId, post, loading, dispatch]);

  if (loading && !post) {
    return (
      <div className="post-link-preview" style={{ margin: "8px 0" }}>
        <div
          style={{
            padding: "12px",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
          }}
        >
          <div className="flex gap-2">
            <IonSkeletonText
              animated
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
            />
            <div className="flex-1">
              <IonSkeletonText
                animated
                style={{ width: "60%", height: "16px", marginBottom: "8px" }}
              />
              <IonSkeletonText
                animated
                style={{ width: "80%", height: "14px" }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return null; // Don't show anything if there's an error or no post
  }

  return (
    <div
      className="post-link-preview"
      style={{
        margin: "8px 0",
        cursor: "pointer",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        transition: "all 0.2s ease",
        opacity: 0.9,
      }}
    >
      <FeedItem post={post} />
    </div>
  );
};

export default PostLinkPreview;
